<template>
  <div class="fw-steps-anchor" :ref="setNavRef" :style="anchorStyle">
    <div class="fw-steps-nav" :class="[ { 'fw-steps-nav--open': mobileOpen, 'fw-steps-nav--stuck': isStuck } ]">
      <!-- Mobile: Dropdown toggle -->
      <button
        class="fw-steps-toggle"
        @click="toggleMobile"
        :aria-expanded="mobileOpen"
        aria-haspopup="listbox"
      >
        <span class="fw-steps-toggle__label">
          <span class="fw-steps-toggle__index">{{ (current$ && current$.index !== undefined ? current$.index : 0) + 1 }}/{{ Object.keys(visible$ || {}).length }}</span>
          <span class="fw-steps-toggle__text" v-html="current$ && current$.stepLabel ? current$.stepLabel : ''"></span>
        </span>
        <span v-if="invalidStepCount > 0" class="fw-steps-toggle__error" :aria-label="t('offscreenErrors')">
          <span class="fw-steps-toggle__error-icon">!</span>
          <span class="fw-steps-toggle__error-count">{{ invalidStepCount }}</span>
        </span>
        <svg class="fw-steps-toggle__chevron" :class="{ 'fw-steps-toggle__chevron--open': mobileOpen }" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>

      <!-- Desktop: scrollable step bar with arrows -->
      <div class="fw-steps-scroll-wrapper">
        <!-- Left scroll arrow -->
        <button
          v-if="canScrollLeft"
          class="fw-steps-arrow fw-steps-arrow--left"
          @click="scrollBy(-1)"
          :aria-label="t('scrollLeft')"
        >
          <svg viewBox="0 0 64 66" fill="currentColor">
            <g transform="translate(64,66) scale(-0.1,-0.1)">
              <path d="M137 493c-20-19-3-60 48-120l55-65-56-63c-44-51-55-70-52-92 2-22 9-29 29-31 23-3 38 10 100 83 41 48 74 95 74 105 0 30-142 190-169 190-12 0-26-3-29-7z"/>
              <path d="M265 480c-4-6 22-44 57-86 35-41 63-79 63-84 0-5-28-43-62-84-64-77-74-96-49-96 15 0 166 163 166 180 0 12-150 180-161 180-4 0-11-5-14-10z"/>
              <path d="M355 481c-3-5 24-44 60-86 36-42 65-81 65-87 0-5-29-43-65-84-61-70-72-94-41-94 14 0 156 164 156 180 0 16-143 180-157 180-6 0-14-4-18-9z"/>
            </g>
          </svg>
        </button>

        <!-- Fade indicators -->
        <div v-if="canScrollLeft" class="fw-steps-fade fw-steps-fade--left"></div>
        <div v-if="canScrollRight" class="fw-steps-fade fw-steps-fade--right"></div>

        <!-- Step list -->
        <ul :class="classes.wrapper" class="fw-steps-list" role="tablist" :ref="setListRef" @click="closeMobile">
          <slot>
            <FormStep
              v-for="(step, name) in steps"
              v-bind="step"
              :name="name"
              :key="name"
            />
          </slot>
        </ul>

        <!-- Right scroll arrow -->
        <button
          v-if="canScrollRight"
          class="fw-steps-arrow fw-steps-arrow--right"
          @click="scrollBy(1)"
          :aria-label="t('scrollRight')"
        >
          <svg viewBox="0 0 64 66" fill="currentColor">
            <g transform="translate(0,66) scale(0.1,-0.1)">
              <path d="M137 493c-20-19-3-60 48-120l55-65-56-63c-44-51-55-70-52-92 2-22 9-29 29-31 23-3 38 10 100 83 41 48 74 95 74 105 0 30-142 190-169 190-12 0-26-3-29-7z"/>
              <path d="M265 480c-4-6 22-44 57-86 35-41 63-79 63-84 0-5-28-43-62-84-64-77-74-96-49-96 15 0 166 163 166 180 0 12-150 180-161 180-4 0-11-5-14-10z"/>
              <path d="M355 481c-3-5 24-44 60-86 36-42 65-81 65-87 0-5-29-43-65-84-61-70-72-94-41-94 14 0 156 164 156 180 0 16-143 180-157 180-6 0-14-4-18-9z"/>
            </g>
          </svg>
        </button>

        <!-- Off-screen error indicator -->
        <div v-if="hasOffscreenErrors" class="fw-steps-error-hint" @click="scrollToFirstError">
          <span class="fw-steps-error-hint__badge">!</span>
          <span class="fw-steps-error-hint__text">{{ t('offscreenErrors') }}</span>
        </div>
      </div>

      <!-- Backdrop for mobile dropdown -->
      <div v-if="mobileOpen" class="fw-steps-backdrop" @click="closeMobile"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FormSteps',
    data() {
      return {
        merge: true,
        defaultClasses: {
          container: 'vf-steps-container',
          container_sm: 'vf-steps-container-sm',
          container_md: '',
          container_lg: 'vf-steps-container-lg',
          wrapper: 'vf-steps-wrapper',
          $container: (classes, { Size }) => ([
            classes.container,
            classes[`container_${Size}`],
          ]),
        }
      }
    }
  }
</script>

<!-- Styles in assets/styles/newform/_steps.scss -->
